import { useState } from "react";

/**
 * Reference Market2/6/7/8 getClass(odds, otype, tno, sectionIndex): each price box compares its odds
 * with the same box in the previous feed (gameData.old, markets and sections in sno order) and gets
 * .bg-success when the price went up, .bg-danger when it went down. UI state only (no extra fetch).
 */

const bySno = (list) => [...(list || [])].sort((a, b) => (Number(a?.sno) || 0) - (Number(b?.sno) || 0));

// Previous `data` value (the feed before the current one); the first feed compares with itself.
export function usePreviousFeed(data) {
  const [pair, setPair] = useState({ cur: data, old: data });
  if (pair.cur !== data) {
    setPair({ cur: data, old: pair.cur });
    return pair.cur;
  }
  return pair.old;
}

// Old market at the same position as markets[i] (reference: orderBy(gameData.old, "sno")[i])
export const oldMarketAt = (oldData, i) => bySno(oldData)[i];

// " bg-success" | " bg-danger" | "" — vue2-filters filterBy/find are case-insensitive "contains"
export function oddsChangeClass(oldMarket, sectionIndex, otype, tno, odds) {
  const section = bySno(oldMarket?.section)[sectionIndex];
  const prev = (section?.odds || [])
    .filter((o) => String(o?.otype ?? "").toLowerCase().includes(String(otype).toLowerCase()))
    .find((o) => String(o?.tno ?? "").includes(String(tno)));
  const now = Number(odds);
  const was = prev?.odds === undefined ? now : Number(prev.odds);
  return was < now ? " bg-success" : was > now ? " bg-danger" : "";
}
